import React from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useInView } from 'react-hook-inview';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

import BackButton from '../components/BackButton';
import Button from '../components/Button';
import RadioGroup from '../components/RadioGroup';
import StackForm from '../components/StackForm';
import Title from '../components/Title';

import { pickups, pickupsInterior, zonas } from '../data';
import { breakpoints } from '../config';
import useStore from '../store';
import { click_next_step8 } from '../techspec';

const Pickup = props => {
  const { register, errors, watch, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);
  const [ref, inView] = useInView();
  const selectedPickup = watch('pickup');
  const [{ mostrarReferidos }, setStore] = useStore();

  const onSubmit = data => {
    action(data);

    click_next_step8();

    if (mostrarReferidos) {
      props.history.push({ pathname: '/8', state: 'retiro' });
    } else {
      props.history.push({ pathname: '/9', state: 'retiro' });
    }
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Seleccioná el lugar de retiro.</Title>

        {state.data.zona === zonas[0].value ? (
          <RadioGroup
            name="pickup"
            variant="details"
            register={register({ required: 'Debe seleccionar un lugar de retiro.' })}
            error={errors.pickup}
            options={pickups.map(pickup => ({
              label: pickup.title,
              id: pickup.id,
              value: pickup.value,
              subtitle: pickup.address,
              details: (
                <>
                  {pickup?.details.map((item, i) => (
                    <p key={`p-${i}`}>{item}</p>
                  ))}
                </>
              ),
            }))}
            defaultChecked={state?.data?.pickup}
          />
        ) : (
          <RadioGroup
            name="pickup"
            variant="details"
            register={register({ required: 'Debe seleccionar un lugar de retiro.' })}
            error={errors.pickup}
            options={pickupsInterior.map(pickup => ({
              label: pickup.title,
              id: pickup.id,
              value: pickup.value,
              subtitle: pickup.address,
              details: (
                <>
                  {pickup?.details.map((item, i) => (
                    <p key={`p-${i}`}>{item}</p>
                  ))}
                </>
              ),
            }))}
            defaultChecked={state?.data?.pickup}
          />
        )}
      </div>

      <div className="fixed-actions">
        <Button block type="submit">
          Siguiente
        </Button>

        <BackButton />
      </div>

      <div className="form-actions" ref={ref}>
        <Button block type="submit" id="next-button-step-7">
          Siguiente
        </Button>

        <BackButton />
      </div>

      <style jsx>{`
        .fixed-actions {
          padding: 32px 24px 0 24px;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          transition: transform 0.25s ease;
          transform: translateY(${selectedPickup && !inView ? 0 : 100}%);
          background-color: #fff;
          box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
        }

        @media screen and (min-width: ${breakpoints.md}) {
          .fixed-actions {
            display: none !important;
          }
        }
      `}</style>
    </StackForm>
  );
};

export default withRouter(Pickup);
